import EmptyDottedIcon from '@assets/icons/empty-dotted.svg';
import i18n from '@/utils/i18n';
import React from 'react';
import { EmptyState } from '@experiences/components/empty-state';
import { useTheme } from '@/contexts/theme-context';

const ICON_SIZE = 48;

/**
 * Props for {@link ItemDetailEmptyState}.
 */
export interface ItemDetailEmptyStateProps {
  /** Item display name, interpolated into the description copy. */
  itemName: string;
}

/**
 * Empty state shown when the loader returns successfully but every section
 * (purchase history, related VPs, salt info, custom display configs) is empty.
 *
 * @param props - {@link ItemDetailEmptyStateProps}.
 * @returns The rendered empty state.
 */
export const ItemDetailEmptyState: React.FC<ItemDetailEmptyStateProps> = ({
  itemName,
}) => {
  const theme = useTheme();
  return (
    <EmptyState
      description={i18n.t(
        'sales_portal.order_entry.item_detail.empty.description',
        { itemName },
      )}
      iconElement={
        <EmptyDottedIcon
          fill={theme.sk.color.icon.primary}
          height={ICON_SIZE}
          width={ICON_SIZE}
        />
      }
      title={i18n.t('sales_portal.order_entry.item_detail.empty.title')}
    />
  );
};
